export default __webpack_public_path__ + "static/salad-714227babec362bdcfefd386c291a112.svg";